import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import HomePageContainer from "./home/HomePage.container"; // eslint-disable-line import/no-named-as-default
import HomePageAuthContainer from "./auth/HomePage.container"; // eslint-disable-line import/no-named-as-default
import RecipeFormAuthContainer from "./auth/RecipeForm.container"; // eslint-disable-line import/no-named-as-default
import RecipePageContainer from "./recipes/RecipePage.container"; // eslint-disable-line import/no-named-as-default
import UserProfileContainer from "./profile/ProfilePage.container"; // eslint-disable-line import/no-named-as-default
import PrivateRoute from "./auth/PrivateRoute";
import PageNotFound from "./notFound/PageNotFound";
import Login from "./auth/Login";
import Registration from "./auth/Registration";
import Logout from "./common/Logout";
import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { auth } from "../utils/firebase";
//redux
import * as userActions from "../redux/actions/userActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class App extends Component {
  state = {
    accessToken: sessionStorage.getItem("cb_token"),
  };

  componentDidMount() {
    auth().onAuthStateChanged((user) => {
      if (user) {
        auth()
          .currentUser.getIdToken()
          .then((_token) => {
            this.setAccessToken(_token);
          });
      } else {
        sessionStorage.clear();
        this.props.actions.clearUser();
        this.setState({ accessToken: null });
      }
    });
  }

  setAccessToken = (token) => {
    window.sessionStorage.setItem("cb_token", token);
    this.setState({ accessToken: token });
  };

  renderApp = () => {
    return (
      <div className="container-fluid">
        <div className="main-content">
          <Header signedIn={this.state.accessToken ? true : false} />
          <Switch>
            <Route exact path="/cookbook" component={HomePageContainer} />
            <Route
              path="/cookbook/login"
              render={() =>
                this.state.accessToken ? (
                  <Redirect to="/cookbook/profile" />
                ) : (
                  <Login />
                )
              }
            />
            {/* <Route
              path="/cookbook/registration"
              render={() =>
                this.state.accessToken ? (
                  <Redirect to="/cookbook/profile" />
                ) : (
                  <Registration />
                )
              }
            /> */}
            <Route
              path="/cookbook/recipe/:slug"
              component={RecipePageContainer}
            />
            <Route
              path="/cookbook/user/:username/"
              component={UserProfileContainer}
            />
            <PrivateRoute
              path="/cookbook/profile/:userID/recipe/:id"
              accessToken={this.state.accessToken}
              component={RecipeFormAuthContainer}
            />
            <PrivateRoute
              path="/cookbook/profile/:userID/recipe/"
              accessToken={this.state.accessToken}
              component={RecipeFormAuthContainer}
            />
            <PrivateRoute
              path="/cookbook/profile/favorites"
              accessToken={this.state.accessToken}
              component={HomePageAuthContainer}
            />
            <PrivateRoute
              path="/cookbook/profile/"
              accessToken={this.state.accessToken}
              component={HomePageAuthContainer}
            />
            <Route path="/cookbook/logout" component={Logout} />
            <Route component={PageNotFound} />
          </Switch>
          <ToastContainer autoClose={3000} hideProgressBar />
          <Footer signedIn={false} />
        </div>
      </div>
    );
  };

  render() {
    return this.renderApp();
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      clearUser: bindActionCreators(userActions.clearUser, dispatch),
    },
  };
}

function mapStateToProps(state) {
  return {
    signedIn: state.user.signedIn,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
